/*global s*/
/*eslint no-undef: "error"*/
export const triggerSearchEvent = (searchTerm, resultsLength) => {
  if (typeof s !== 'undefined') {
    s.pfSearch(searchTerm, 'site', String(resultsLength), 'false');
  }
};

/*eslint no-undef: "error"*/
export const pageLoad = path => {
  if (typeof s !== 'undefined') {
    s.pageURL = window.location.href;
    s.pfPageLoad(path);
  }
};

export default {
  triggerSearchEvent,
  pageLoad,
};
